<template>
    <ul class="table__navigation__pages" v-if="meta && meta.last_page > 1">
        <template v-if="meta.last_page <= 20">

            <li class="navigation__total">{{ meta.from }} - {{ meta.to }} {{$t('common.of')}} {{ meta.total }} {{$t('common.items')}}</li>

            <li  :class="{ disabled: meta.current_page == 1 }" class="prev"><a @click.prevent="goToPage(meta.current_page-1)"><i class="form__icon icons icon-arrow-left"/></a></li>

            <li v-for="pageNo in meta.last_page" :key="pageNo" :class="{ active: meta.current_page === pageNo}"><a @click.prevent="goToPage(pageNo)">{{ pageNo }}</a></li>

            <li :class="{ disabled: meta.current_page == meta.last_page }" class="next"><a @click.prevent="goToPage(meta.current_page+1)"><i class="form__icon icons icon-arrow-right"/></a></li>

        </template>
        <template v-else>
            <li><a @click.prevent="goToPage(1)"><i class="form__icon icons icon-arrow-left"/></a></li>

            <template v-if="meta.current_page > 1">
                <li v-for="pageNo in (meta.current_page > 3 ? 3 : meta.current_page - 1)" :key="'first' + pageNo">
                    <a @click.prevent="goToPage(meta.current_page + pageNo - (meta.current_page > 3 ? 4 : meta.current_page))">
                        {{ meta.current_page + pageNo - (meta.current_page > 3 ? 4 : meta.current_page)}}
                    </a>
                </li>
            </template>

            <li class="active">
                <a @click.prevent="goToPage(meta.current_page)">
                    {{ meta.current_page}}
                </a>
            </li>

            <template v-if="(meta.last_page - meta.current_page) > 0">
                <li v-for="pageNo in ((meta.current_page > meta.last_page - 3) ? meta.last_page - meta.current_page : 3)" :key="'last' + pageNo">
                    <a @click.prevent="goToPage(meta.current_page + pageNo)">
                        {{ meta.current_page + pageNo }}
                    </a>
                </li>
            </template>

            <li><a @click.prevent="goToPage(meta.last_page)"><i class="form__icon icons icon-arrow-right"/></a> </li>
        </template>
    </ul>
</template>
<script>
    import Vue from 'vue';
    import { Prop, Component }  from 'vue-property-decorator';

    @Component()
    export default class Pagination extends Vue {
        @Prop() meta;

        goToPage(pageNo) {
            this.$emit('goToPage', pageNo);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/tables/Pagination.vue